import React from "react";
import autoBind from "react-autobind";
import _ from "lodash";
import {
	Button
} from "react-bootstrap";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import { branch } from "baobab-react/higher-order";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
import * as playerActions from "../../actions/playerActions";

class PlayerBarcodeScanner extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;

		this.state = {
			value: this.getValueFromItem(this.props.item, "")
		};

		autoBind(this);
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.value); }
	}

	getValueFromItem(item, defaultValue) {
		const value = (item.hasOwnProperty("barcode") && item.barcode.hasOwnProperty("data") && item.barcode.data !== "") ? item.barcode.data : defaultValue;		
		return value;
	}

	onChange(event) {
		this.setState({ value: event.target.value });
	}

	onBlur(event) {
		if (this.props.onChange) { this.props.onChange(event.target.value); }
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.item.barcode !== this.props.item.barcode) {			
			this.setState({ value: this.getValueFromItem(nextProps.item, "") });
		}
	}

	showBarcodeScanner() {
		this.props.dispatch(
			playerActions.showBarcodeScanner
		);
	}


	handleClearBarcode() {
		const itemSelected = this.props.selected;
		if (itemSelected) {
			this.props.dispatch(
				playerActions.clearBarcode
			);
		}
		/*
		else {
			this.props.dispatch(
				playerActions.setSelectedItemAndSave,
				this.props.listIndex,
				this.props.sectionIndex,
				this.props.itemIndex,
				true);
		}
		*/
	}
	
	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}
	renderReadOnly() {
		const item = this.props.item;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{this.props.getImage()}
					{this.props.getVideo()}
					{this.props.getPdf()}
					<div>
						{
							this.getValueFromItem(item, "(No Data)")
						}
					</div>
				</div>
			</div>
		);
	}

	renderEditable() {
		const { item, listIndex, sectionIndex, itemIndex, disabled } = this.props;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;

		const barCodeScannerTheme = _.assign({ marginBottom: "15px" }, _.get(theme, "item.barcodeScanner", {}));

		let clearBarcode;

		if (item.hasOwnProperty("barcode") && item.barcode && item.barcode.data !== "") {
			clearBarcode = <Button onClick={this.handleClearBarcode} style={_.assign({}, barCodeScannerTheme.buttons.clear, { marginTop: 5, width: 32 })}><FontAwesomeIcon style={barCodeScannerTheme.buttons.clearText} icon="trash" /></Button>;
		}

		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ width: "100%" }}>
				<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
				<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
				{this.props.getImage()}
				{this.props.getVideo()}
				{this.props.getPdf()}
				<div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
					<textarea
						rows={5}
						style={barCodeScannerTheme.textInput}
						className="form-control"
						type="text"
						value={this.state.value}
						onChange={this.onChange}
						onBlur={this.onBlur}
						disabled={disabled}
						ref={(ref) => { this.textInput = ref; }} />
					<Button onClick={this.showBarcodeScanner} style={_.assign({}, barCodeScannerTheme.buttons.scan, { border: "none", marginTop: 5, width: 28 })} bsStyle="primary"><FontAwesomeIcon icon="barcode" style={barCodeScannerTheme.buttons.scanText} /></Button>					
					{clearBarcode}
				</div>
				{!disabled && <DoneButton onSubmit={this.onSubmit} />}
			</div>
		</div>;
		return component;
	}
}

export default branch({}, withPlayerItemHoc(PlayerBarcodeScanner));